export const EDCOMP_TITLE = 'EDCOMP_TITLE' ; 
export const EDCOMP_PARAG = 'EDCOMP_PARAGRAPH'
export const EDCOMP_FEEDBACK = 'EDCOMP_FEEDBACK'
export const EDCOMP_VIDEO_EXTERNAL = 'EDCOMP_VIDEO_EXTERNAL'
export const EDCOMP_LIST = 'EDCOMP_LIST'
export const EDCOMP_BREAK = 'EDCOMP_BREAK'
export const EDCOMP_EQN_SEQUENCE = 'EDCOMP_EQN_SEQUENCE'
export const EDCOMP_MOVIE_CAROUSEL= 'EDCOMP_MOVIE_CAROUSEL'
export const EDCOMP_EQUATION = 'EDCOMP_EQUATION'
export const EDCOMP_MULTI_EQUATION = 'EDCOMP_MULTI_EQUATION'
export const EDCOMP_EQN_MULTILINE = 'EDCOMP_EQN_MULTILINE'
export const EDCOMP_FIGURE = 'EDCOMP_FIGURE' 
export const EDCOMP_MULTIFIGURE = 'EDCOMP_MULTIFIGURE' 
export const EDCOMP_INT_FIGURE_DISCRETE = 'EDCOMP_INT_FIGURE_DISCRETE'
export const EDCOMP_LOREM = 'EDCOMP_LOREM'
export const EDCOMP_INT_FIGURE = 'EDCOMP_INT_FIGURE'
export const EDCOMP_INT_SLIDER = 'EDCOMP_INT_SLIDER'
export const EDCOMP_INT_CHECKBOX = 'EDCOMP_INT_CHECKBOX'
export const EDCOMP_INT_LINE = 'EDCOMP_INT_LINE'
export const EDCOMP_INT_POINT = 'EDCOMP_INT_POINT'
export const EDCOMP_INT_LINE_2D = 'EDCOMP_INT_LINE2D'
export const EDCOMP_INT_CONTOURPLOT = 'EDCOMP_INT_CONTOURPLOT'
export const EDCOMP_INT_BINARY_MAP = 'EDCOMP_INT_BINARY_MAP'
export const EDCOMP_INT_TEXT = 'EDCOMP_INT_TEXT'
export const EDCOMP_INT_MOVABLE_POINT = 'EDCOMP_INT_MOVABLE_POINT'
export const EDCOMP_INT_FUNCTION = 'EDCOMP_INT_FUNCTION'
export const EDCOMP_INT_CFUNCTION = 'EDCOMP_INT_CFUNCTION'
export const EDCOMP_INT_SLICE = 'EDCOMP_INT_SLICE'
export const EDCOMP_INT_ACCORDION = 'EDCOMP_INT_ACCORDION'
export const EDCOMP_VERT_SPACE = 'EDCOMP_VERT_SPACE'
export const EDCOMP_PROBLEM_SET = 'EDCOMP_PROBLEM_SET'
export const EDCOMP_PROBLEM_TEXT_QA = 'EDCOMP_PROBLEM_TEXT_QA'
export const EDCOMP_PROBLEM_DROPDOWN_TEXT = 'EDCOMP_PROBLEM_DROPDOWN_TEXT'
export const EDCOMP_PROBLEM_TEXTIMQ_TEXTA = 'EDCOMP_PROBLEM_TEXTIMQ_TEXTA'
export const EDCOMP_PROBLEM_TEXTIMQ_TEXTIMA = 'EDCOMP_PROBLEM_TEXTIMQ_TEXTIMA'
export const EDCOMP_PROBLEM_MULTICHOICE = 'EDCOMP_PROBLEM_MULTICHOICE'
export const EDCOMP_PROBLEM_NOTEBOOK = 'EDCOMP_PROBLEM_NOTEBOOK'
export const EDCOMP_NOTEBOOK = 'EDCOMP_NOTEBOOK'
export const EDCOMP_CHAPTER = 'EDCOMP_CHAPTER'
export const EDCOMP_SECTION = 'EDCOMP_SECTION'
export const EDCOMP_SUBSECTION = 'EDCOMP_SUBSECTION'
export const EDCOMP_ATTRIBUTION = 'EDCOMP_ATTRIBUTION'